<template>
	<article class="post-article-block block" :class="'type-' + data.type" v-if="data">
		<WpLink class="post-link" :url="data.link" :title="data.title">
			<div class="head-block">
				<WpImage
					size="medium_large"
					class="featured"
					:radius="false"
					v-if="data.featured_image"
					:image="data.featured_image"
					cover
					background
				/>
				<div v-else class="featured dummy-image"><div class="img"></div></div>
			</div>
			<div class="inner">
				<span class="post-meta font-size--16">
					<span class="date" v-if="momentDateTime">{{ momentDateTime.format('DD.MM.YYYY') }}</span>
					<span class="separator">•</span>
					<span v-if="categories" class="category" v-html="categories"></span>
				</span>
				<h3 class="titler font-size--26s">
					<span>{{ data.title }}</span>
				</h3>
			</div>
		</WpLink>
	</article>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import PostBlockDate from '@/components/elements/PostBlockDate'
import WpLink from '@/components/elements/WpLink'

import { formatOutputValues } from '@/helpers'
import { mapGetters } from 'vuex'

import moment from 'moment'
moment.locale('nb-NO')

export default {
	name: 'post-block',
	props: {
		data: {
			type: Object,
			default: {},
		},
	},
	data() {
		return {
			momentDateTime: '',
		}
	},
	components: {
		WpImage,
		WpLink,
		PostBlockDate,
	},
	created() {
		this.momentDateTime = this.data.date ? moment(this.data.date) : false
	},
	computed: {
		...mapGetters(['storedTaxonomy']),
		categories() {
			let cats = []
			if (this.data && this.data.acf && this.data.acf.post_category && this.data.acf.post_category.name) {
				//single choice fallback
				cats = [this.data.acf.post_category]
			} else if (
				this.data &&
				this.data.acf &&
				this.data.acf.post_category &&
				this.data.acf.post_category.length
			) {
				//multi choice fallback
				cats = this.data.acf.post_category
			}
			cats = cats && cats.length ? cats.map((c) => c.name) : []
			return formatOutputValues(cats)
		},
	},
	mounted() {},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

.post-article-block {
	.excerpt {
		margin-top: 15px;
		margin-bottom: 0;
	}
	.wp-image-vue {
		@include transition(background, 0.15s);
	}
	.inner {
		padding: 25px 25px 30px;
	}
	.titler {
		margin: 0;
		margin-top: 10px;
	}
	.separator {
		margin: 0 5px;
	}
	.post-link {
		text-decoration: none;
		background-color: var(--gray);
		display: block;
		border-radius: $radius;
		height: 100%;
		transition: box-shadow 0.15s ease-in-out;
		&:hover {
			box-shadow: 0 0 0 2px var(--dark);
		}
	}
	.dummy-image .img,
	div.image {
		border-top-left-radius: $radius;
		border-top-right-radius: $radius;
	}

	.dummy-image .img {
		height: 0;
		background-color: var(--gray);
		padding-bottom: 56.4%;
	}
	.head-block {
		position: relative;
	}
}
</style>
